"use client";

import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "../../Modal/Modal";
import { TextField } from "../../TextField/TextField";
import { searchIconStyle, searchStyle } from "./HistorySearchModal.css";
import { Ruler } from "../../Ruler/Ruler";
import { Flex } from "../../Flex/Flex";
import { Icon } from "../../Icon/Icon";

type HistorySearchModalProps = {
  onClose: () => void;
};

export const HistorySearchModal: FC<HistorySearchModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal closeable escape onClose={onClose} placement="center" padding="m">
      <Flex direction="column" gap="s">
        <TextField
          autoFocus
          leading={
            <Icon
              className={searchIconStyle}
              icon="search"
              size="s2"
              color="placeholder"
            />
          }
          placeholder={t("history.search")}
          className={searchStyle}
          variant="opaque"
          typography="bodyL"
          size="minimal"
        />
        <Ruler />
      </Flex>
    </Modal>
  );
};
